import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Logo } from '@guildeducationinc/recess';
import ArrowBackIcon from '@guildeducationinc/recess/icons/ArrowBackIcon';
import { useBackTo } from '@src/hooks/useBackTo';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import styles from './TopBar.module.scss';
export const TopBar = ({ backLink }) => {
    const { t } = useLocale();
    const backTo = useBackTo();
    return (_jsx("div", { className: styles.wrapper, children: _jsxs("div", { className: styles.topBar, children: [_jsx("div", { className: styles.exit, children: _jsx(TrackableButton, { enText: 'Exit', tag: 'top_bar', appearance: 'ghost', onClick: () => backTo(backLink), children: _jsxs("span", { className: 'flex flexItems--center', children: [_jsx(ArrowBackIcon, { size: 20, className: 'mr-2' }), t('Exit')] }) }) }), _jsx("div", { className: styles.logo, children: _jsx(Logo, { alt: '', cobranded: true }) }), _jsx("div", {})] }) }));
};
